/**
*
*   Cart Form Popup
*       - A left/right content block + image or video
*
**/
'use client';

import Image from '@/components/image';
import ShopifyTools from '@/libraries/shopify-tools/class';
import { CartContext } from '@/context/cart';
import { useRouter, usePathname, useSearchParams } from 'next/navigation';
import { ModalContext } from '@/context/modal';
import { useEffect , useContext } from 'react';
import { useTranslations } from 'next-intl';
//import 'swiper/css';

//Build the Element
export default function CartDiscounts({ children , ...props }){

	//Load Translations
	const t = useTranslations();

	//Load the Modal Context
	const { Modal } = useContext(ModalContext);

	//Load the Cart Discounts
	const { Discounts } = useContext(CartContext);

	//Load the Search Params
	const searchParams = useSearchParams();

	//
	const router = useRouter();

	//
	const pathname = usePathname();

	//Load the Offers
	const offers = ( obj => {

		//Load all params
		for( const key in obj )
			obj[ key ] = searchParams.get( key );

		//Return
		return obj;

	})({
		discount: null,
		referral: null
	});


	//Load
	useEffect(()=>{
		( async () => {

			const params = new URLSearchParams( searchParams.toString() );

			//Rewards Referral Offer
			if( offers.referral ){

				//
				const validate = await ShopifyTools.Rewards.referral.validate(offers.referral);
				const result   = ( validate.result ? 'eligible' : 'ineligible' );

				//Open the Messaging
				Modal.open({
					content: (
						<div className="reward-flex">
							<div className="left">
								<Image src={ 'icons/icon-refer-a-friend.svg' } alt="" width="61" height="61" />
							</div>
							<div className="right">
								<h2>{ t(`Components.Modal.Referral.${ result }.title`) }</h2>
								<p>{ t(`Components.Modal.Referral.${ result }.content`) }</p>
							</div>
						</div>
					),
					attributes: {
						className: 'rewards'
					}
				});

				//If we have an active referral, add the code
				if( validate.result )
					Discounts.add( validate.code );

				//Remove the Referral
				params.delete('referral');

				//Remove the Param from the URL
				router.replace(`${ pathname }${ params != '' ? `?${  params }` : '' }`);

			}


			if( offers.discount ){

				//Add the Discount
				Discounts.add( offers.discount );

				//Remove the Discount Code
				params.delete('discount');

				//Remove the Param from the URL
				router.replace(`${ pathname }${ params != '' ? `?${  params }` : '' }`);

			}


		})();
	},[]);


	//Return
	return <>{ children }</>;

}